
    import MainController from "@/controller/MainController";
    import useController from "@/lib/useController";

    export default useController(new MainController());
